import type { Dispatch, SetStateAction } from "react";
import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { ImportCsvDataPageState } from "./importCsvDataPageState";

export interface Props {
  pageState: ImportCsvDataPageState;
  setPageState: Dispatch<SetStateAction<ImportCsvDataPageState>>;
}

type ContextValue = Props;

export const ImportCsvDataContext = createContext<ContextValue | undefined>(undefined);

export const useImportCsvDataContext = () =>
  defined(use(ImportCsvDataContext), "Attempt to use ImportCsvDataContext without provider");
